<template>
  <div class="todo_list">
    <div class="list_loading" v-if="isLoadingList">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <ol class="cl" v-sortable='sortOption' v-if="!isLoadingList" v-el:sort-list>
      <li v-for="item in todoList" :class="{finish: item.todo_status == 'completed'}">
        <todo-item :item="item" :index="$index" @delete-succeed="handleOperateSucceed" @update-succeed="handleOperateSucceed"></todo-item>
      </li>
    </ol>
    <div v-el:cover-ele v-show="isCover" style="position: absolute ;opacity: 0;"></div>
    <div class="create">
      <div class="checkbox"><i>&#xe900;</i></div>
      <todo-create :placeholder="'我想...'" @input-box-change="handleInputBoxChange"></todo-create>
    </div>
  </div>
</template>

<script>
  import TodoItem from './todo-item'
  import InputBox from './input-box'
  import TodoCreate from './todo-create'
  import {createTodo, getTodos, updateTodosOrder} from 'src/vuex/actions'
  export default {
    name: 'todo-list',
    components: {
      TodoItem,
      InputBox,
      TodoCreate
    },

    vuex: {
      getters: {
        todoList: state => state.todo.todoList,
        isLoadingList: state => state.todo.isLoadingList,
        oldIds: state => state.todo.oldIds
      },
      actions: {
        getTodos,
        createTodo,
        updateTodosOrder
      }
    },

    ready() {
      this.getTodos()
    },

    data() {
      return {
        sortOption: {
          sort: true,
          animation: 150,
          onStart: this.handleSortStart,
          onEnd: this.handleSortEnd,
          ghostClass: 'ghost',
          handle: '.drag',
          delay: window.HuobanAppSDK.isMobile ? 200 : 0
        },
        isCover: false
        // isFinished: true
      }
    },

    computed: { },
    methods: {
      handleSortEnd(evt) {
        if (evt.newIndex && evt.newIndex != evt.oldIndex) {
          this.computeCoverAttr()
          this.isCover = true
          let idList = []
          this.todoList.forEach((item) => {
            idList.push(item.id)
          })
          let tempId = idList.splice(evt.oldIndex,1)[0]
          idList.splice(evt.newIndex, 0, tempId)
          if (idList.join('') != this.oldIds.join('')) {
            this.updateTodosOrder(idList).then(() => {
              this.isCover = false
            })
          }
        }
      },
      handleSortStart(evt) {
        console.log(evt.item)
      },
      handleInputBoxChange(text) {
        if (text != '') {
          this.createTodo(text)
          this.$broadcast('create-succeed')
        }
      },
      computeCoverAttr() {
        let sortElePosition = $(this.$els.sortList).position()
        $(this.$els.coverEle).width($(this.$els.sortList).width())
        $(this.$els.coverEle).height($(this.$els.sortList).height())
        $(this.$els.coverEle).css({
          left: sortElePosition.left,
          top: sortElePosition.top
        })
      },
      handleOperateSucceed(index, isBlur) {
        if (!isBlur && index < this.todoList.length) {
          this.$broadcast('input-focus', index+1)
        }
      }
      // handleChangeStatus(isFinished) {
      //   this.isFinished = isFinished
      // }
    }
  }
  </script>


/** WEBPACK FOOTER **
 ** todo-list.vue?4c12a450
 **/